<template>
  <ul class="pagination justify-content-center mb-0 mt-3 pagination-sm">
    <li
      v-if="pagesCount > 1"
      :class="['page-item', { disabled: currentPage === 0 }]"
    >
      <span
        class="d-flex align-items-center page-link cursor-pointer"
        aria-disabled="true"
        @click.prevent="paginate(currentPage - 1)"
      >
        <i class="gf-icon gf-icon-arrow-left" />
      </span>
    </li>
    <li v-if="firstPage > 0">
      <span
        class="page-link cursor-pointer"
        aria-disabled="true"
        @click.prevent="paginate(0)"
      >
        1
      </span>
    </li>
    <li
      v-if="firstPage > 2"
      class="page-item paginator-ellipsis"
    >
      <span
        class="page-link"
        aria-disabled="true"
      >
        ...
      </span>
    </li>
    <li
      v-for="i in visiblePages"
      :key="i"
      :class="['page-item', { active: i === currentPage }]"
    >
      <span
        class="page-link cursor-pointer"
        :aria-disabled="true"
        @click.prevent="paginate(i)"
      >
        {{ i + 1 }}
      </span>
    </li>
    <li
      v-if="pagesCount - lastPage > 2"
      class="page-item paginator-ellipsis"
    >
      <span
        class="page-link"
        aria-disabled="true"
      >
        ...
      </span>
    </li>
    <li
      v-if="lastPage < pagesCount - 1"
      :class="['page-item', 'enabled']"
    >
      <span
        class="page-link cursor-pointer"
        :aria-disabled="true"
        @click.prevent="paginate(pagesCount - 1)"
      >
        {{ pagesCount }}
      </span>
    </li>
    <li
      v-if="pagesCount > 1"
      :class="['page-item', { disabled: currentPage === lastPage }]"
    >
      <span
        class="d-flex align-items-center page-link cursor-pointer"
        :aria-disabled="true"
        @click.prevent="paginate(currentPage + 1)"
      >
        <i class="gf-icon gf-icon-arrow-right" />
      </span>
    </li>
  </ul>
</template>

<script>
const pagesLine = 7;

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Pagination',
  props: {
    pager: Object
  },
  computed: {
    pagesCount() {
      return this.pager.totalPages;
    },
    currentPage() {
      return this.pager.number;
    },
    firstPage() {
      let firstPage = this.currentPage - Math.floor(pagesLine / 2);
      if (firstPage < 0) {
        firstPage = 0;
      } else if (this.pagesCount - firstPage < pagesLine) {
        firstPage = this.pagesCount - pagesLine + 1;
      }
      if (firstPage - 2 <= 0) {
        firstPage -= 1;
      }
      return Math.max(firstPage, 0);
    },
    lastPage() {
      let lastPage = this.firstPage + pagesLine - 1;
      if (lastPage + 2 >= this.pagesCount - 1) {
        lastPage += 1;
      }
      return Math.min(lastPage, this.pagesCount - 1);
    },
    visiblePages() {
      const pages = [];
      for (let i = this.firstPage; i <= this.lastPage; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    paginate(page) {
      this.$emit('change', page + 1);
    }
  }
};
</script>
